export const PickupType = {
  DEBIT: 'debit',
  CREDIT: 'credit',
};

export const PickupDetailProvider = (t, title) => {
  return {
    [PickupType.DEBIT]: {
      title: title
        ? t('{merchant name} stores', { '{merchant name}': title })
        : t('Nearby stores'),
      text: t('Visit any of the merchants listed below from 12PM to 9PM'),
      alert: t("Don't forget to show your ID at the store"),
    },
    [PickupType.CREDIT]: {
      title: t('Activate your credit line!'),
      text: t('Visit any of the merchants listed below from 12PM to 9PM'),
      alert: t("Don't forget to show your ID at the store"),
    },
  };
};

export const PickupListingProvider = t => {
  return {
    [PickupType.DEBIT]: {
      title: t('Pick up stores'),
      text: t('Visit any of the merchants listed below from 12PM to 9PM'),
      alert: t("Don't forget to show your ID at the store"),
    },
    [PickupType.CREDIT]: {
      title: t('Activate your credit line!'),
      text: t('Visit any of the merchants listed below from 12PM to 9PM'),
      alert: t("Don't forget to show your ID at the store"),
    },
  };
};
